// Shared pricing configuration
export const PRICING_PLANS = {
  free: {
    id: 'free',
    name: 'Free',
    price: '$0',
    period: '/month',
    description: 'Perfect to get started',
    features: [
      '5 AI Generations per month (total)',
      'Basic image generation (512px)',
      '20 seconds voice per day',
      '5 AI scripts per month',
      'Community support',
      'Genova AI watermark'
    ],
    limits: {
      images: 5,
      scripts: 5,
      audioMinutes: 1, // ~20 seconds rounded up
      totalGenerations: 5
    }
  },
  starter: {
    id: 'starter',
    name: 'Starter',
    price: '$4.99',
    period: '/month',
    description: 'Perfect for individuals and small creators',
    features: [
      '20 AI Images per month (1024px)',
      '20 AI Scripts per month',
      '20 minutes voice generation',
      'HD Quality (up to 1024px)',
      'Premium Voice Options',
      'Email Support',
      'Reduced watermark'
    ],
    limits: {
      images: 20,
      scripts: 20,
      audioMinutes: 20
    }
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    price: '$14.99',
    period: '/month',
    description: 'Most popular for professionals',
    features: [
      '40 AI Images per month (1536px)',
      '40 AI Scripts per month',
      '40 minutes voice generation',
      'Full HD quality (up to 1536px)',
      'No watermarks',
      'Priority support',
      'Advanced AI models'
    ],
    limits: {
      images: 40,
      scripts: 40,
      audioMinutes: 40
    }
  },
  business: {
    id: 'team',
    name: 'Team',
    price: '$29.99',
    period: '/month',
    description: 'Perfect for teams and collaboration',
    features: [
      '100 AI Images per month (2048px)',
      '100 AI Scripts per month',
      '100 minutes voice generation',
      '4K Ultra HD (2048px)',
      'No watermarks',
      'Team collaboration',
      'Priority support',
      'Custom branding'
    ],
    limits: {
      images: 100,
      scripts: 100,
      audioMinutes: 100
    }
  }
} as const;

export type PlanId = keyof typeof PRICING_PLANS;
